module.exports = __webpack_public_path__ + "img/loading-thumb-video-play.a5dcfb9e.svg";